import { initI18n, Trans } from '@stitch-fix/i18n';

const { loadTranslations } = initI18n();

export { loadTranslations, Trans };
